import gql from 'graphql-tag';

const GraphQL = {
  Query: {
    LIST_ASSESSMENT_COURSES: gql`
      query ListGroupAssessmentCourses($groupkey: Int!) {
        listGroupAssessmentCourses(groupkey: $groupkey) {
          coursekey
          title
          description
          created
          published
        }
      }
    `,
    LIST_SUBMITTED_LESSONS: gql`
      query SubmittedLessons($groupkey: Int!, $coursekey: Int!) {
        submittedLessons(groupkey: $groupkey, coursekey: $coursekey) {
          userkey
          modulekey
          layer
          moduleversion
          state
          created
          modified
          completed
          expires
          firstname
          lastname
          title
          markerUserkey
          markerFirstname
          markerLastname
        }
      }
    `,
    LIST_SUBMITTED_PORTFOLIOS: gql`
      query SubmittedPortfolios {
        submittedPortfolios {
          coursekey
          course
          modulekey
          module
          userkey
          username
          firstname
          lastname
          email
          layer
          moduleversion
          state
          status
          created
          modified
          completed
          expires
          marker {
            userkey
            firstname
            lastname
          }
          assessors {
            userkey
            firstname
            lastname
          }
        }
      }
    `,
    LIST_ASSESSORS: gql`
      query ListAssessors($groupkey: Int!) {
        listAssessors(groupkey: $groupkey) {
          groupkey
          title
          userkey
          username
          firstname
          lastname
          created
          access
          role
        }
      }
    `,
    PORTFOLIO: gql`
      query Portfolio($userkey: Int!, $modulekey: Int!, $layer: Int!) {
        portfolio(userkey: $userkey, modulekey: $modulekey, layer: $layer) {
          userkey
          modulekey
          layer
          moduleversion
          state
          created
          modified
          completed
          expires
          firstname
          lastname
          title
          markerUserkey
          markerFirstname
          markerLastname
        }
      }
    `,
    COMMENTS: gql`
      query Comments($userkey: Int!, $modulekey: Int!, $layer: Int!) {
        comments(userkey: $userkey, modulekey: $modulekey, layer: $layer) {
          commentkey
          discussionkey
          userkey
          firstname
          lastname
          active
          pinned
          parentkey
          indent
          created
          modified
          assets {
            text
            mediakey
          }
        }
      }
    `
  },
  Mutation: {
    ASSIGN_MARKER: gql`
      mutation AssignMarker(
        $userkey: Int!
        $modulekey: Int!
        $layer: Int!
        $memberkey: Int!
      ) {
        assignMarker(
          userkey: $userkey
          modulekey: $modulekey
          layer: $layer
          memberkey: $memberkey
        ) {
          userkey
          modulekey
          layer
          state
          member {
            userkey
            firstname
            lastname
          }
        }
      }
    `,
    UPDATE_MARK: gql`
      mutation UpdateMark(
        $userkey: Int!
        $modulekey: Int!
        $layer: Int!
        $componentkey: Int!
        $mark: Int!
      ) {
        updateMark(
          userkey: $userkey
          modulekey: $modulekey
          layer: $layer
          componentkey: $componentkey
          mark: $mark
        ) {
          userkey
          modulekey
          layer
          componentkey
          answer
          mark
        }
      }
    `,
    UPDATE_PORTFOLIO_STATE: gql`
      mutation UpdatePortfolioState(
        $userkey: Int!
        $modulekey: Int!
        $layer: Int!
        $state: Int!
      ) {
        updatePortfolioState(
          userkey: $userkey
          modulekey: $modulekey
          layer: $layer
          state: $state
        ) {
          userkey
          modulekey
          moduleversion
          layer
          state
          created
          modified
          completed
          expires
        }
      }
    `,
    COMPLETE_PORTFOLIO: gql`
      mutation CompletePortfolio(
        $userkey: Int!
        $modulekey: Int!
        $layer: Int!
      ) {
        completePortfolio(
          userkey: $userkey
          modulekey: $modulekey
          layer: $layer
        ) {
          userkey
          modulekey
          moduleversion
          layer
          state
          created
          modified
          completed
          expires
        }
      }
    `,
    UNASSIGN_MARKERS: gql`
      mutation UnassignMarkers($userkey: Int!, $modulekey: Int!, $layer: Int!) {
        unassignMarkers(
          userkey: $userkey
          modulekey: $modulekey
          layer: $layer
        ) {
          userkey
          modulekey
          layer
          state
          member {
            userkey
            firstname
            lastname
          }
        }
      }
    `,
    CREATE_COMMENT: gql`
      mutation createComment(
        $userkey: Int!
        $modulekey: Int!
        $layer: Int!
        $text: String!
      ) {
        createComment(
          userkey: $userkey
          modulekey: $modulekey
          layer: $layer
          text: $text
        ) {
          commentkey
          discussionkey
          userkey
          firstname
          lastname
          active
          pinned
          # assetjson
          parentkey
          indent
          created
          modified
          assets {
            text
            mediakey
          }
        }
      }
    `,
    UPDATE_COMMENT: gql`
      mutation updateComment(
        $discussionkey: Int!
        $commentkey: Int!
        $text: String!
        $active: Boolean
      ) {
        updateComment(
          discussionkey: $discussionkey
          commentkey: $commentkey
          text: $text
          active: $active
        ) {
          commentkey
          discussionkey
          userkey
          firstname
          lastname
          active
          pinned
          # assetjson
          parentkey
          indent
          created
          modified
          assets {
            text
            mediakey
          }
        }
      }
    `
  }
};

export default GraphQL;
